<template>
   <div>
      <v-container>
         <confirm-dialog ref="confirm" />
         <v-row class="pt-5"></v-row>
         <v-form ref="locationform" v-model="locationform_valid">
            <v-row>
               <v-toolbar dense :color="this.$globalstore.secondary_titleclass" bottom>
                  <v-toolbar-title> Edit Location </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn color="indigo" class="white ma-2" outlined @click="saveLocation">
                     Save
                  </v-btn>
                  <v-btn color="indigo" class="white ma-2" outlined @click="goBack()">
                     Back
                  </v-btn>
               </v-toolbar>
            </v-row>
            <v-row class="mt-3">
               <v-col md="6">
                  <v-card flat outlined class="pl-5 pr-10 pb-5">
                     <v-text-field
                        ref="locname"
                        label="Name"
                        v-model="edit_location_name"
                        required
                        :rules="rules_location_name"
                     >
                     </v-text-field>

                     <v-text-field
                        label="Description"
                        v-model="edit_location_description"
                        required
                        :rules="rules_location_description"
                     >
                     </v-text-field>
                  </v-card>
               </v-col>
               <v-col md="6">
                  <v-card flat outlined class="pl-5 pr-10 pb-5">
                     <v-select
                        label="Status"
                        :items="status_select"
                        item-text="text"
                        item-value="id"
                        return-object
                        v-model="edit_location_status"
                        @change="statusChange"
                        required
                     ></v-select>

                     <v-select
                        label="Off Site"
                        :items="offsite_select"
                        item-text="text"
                        item-value="id"
                        return-object
                        v-model="edit_location_offsite"
                        @change="offsiteChange"
                        required
                     >
                     </v-select>
                  </v-card>
               </v-col>
            </v-row>
         </v-form>
         <show-toast ref="toast"></show-toast>
      </v-container>
   </div>
</template>

<script>
   import ConfirmDlg from "@/components/ConfirmDlg";
   import ShowToast from "@/components/showToast.vue";

   export default {
      inject: ["ShowMessage"],

      components: {
         "confirm-dialog": ConfirmDlg,
         ShowToast,
      },
      data() {
         return {
            edit_location_id: -1,
            edit_location_name: "",
            edit_location_description: "",
            edit_location_status: 1,
            edit_location_offsite: 0,
            locationform_valid: true,
            status_select: [
               {id: 1, text: "Enabled"},
               {id: 0, text: "Disabled"},
            ],
            offsite_select: [
               {id: 0, text: "No"},
               {id: 1, text: "Yes"},
            ],
            rules_location_name: [(v) => !!v || "Name is required"],
            rules_location_description: [(v) => !!v || "Description is required"],
         };
      },
      methods: {
         goBack() {
            this.$router.go(-1);
         },

         statusChange(item) {
            this.edit_location_status = item.id;
         },

         offsiteChange(item) {
            this.edit_location_offsite = item.id;
         },

         saveLocation() {
            if (!this.$refs.locationform.validate()) {
               this.ShowMessage({
                  title: "Error",
                  message: "Please complete the form.",
                  color: "red",
               });
               return;
            } else {
               this.doSaveLocation();
            }
         },

         async doSaveLocation() {
            await this.$http({
               url: "/cca/updatelocation.php",
               headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
               },
               data: {
                  id: this.edit_location_id,
                  name: this.edit_location_name,
                  description: this.edit_location_description,
                  status: this.edit_location_status,
                  offsite: this.edit_location_offsite,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.$refs.toast.display({
                        message: response.data.message,
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         async getLocationByID(id) {
            await this.$http({
               url: "/cca/getlocation_byid.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {location_id: id},
               method: "POST",
            }).then((response) => {
               let data = response.data.locationdata;
               if (!data.error) {
                  this.edit_location_name = data.location_name;
                  this.edit_location_description = data.location_description;
                  this.edit_location_status = data.location_status;
                  this.edit_location_offsite = data.off_site;
                  this.$refs.locname.focus();
               } else {
                  this.ShowMessage({
                     title: "Error",
                     message: data.message,
                     color: "red",
                  });
               }
            });
         },
      },

      mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            if (this.$route.params.locationid) {
               this.edit_location_id = this.$route.params.locationid;
               this.getLocationByID(this.edit_location_id);
            }
         }
      },
   };
</script>
